import promotionsFieldsQuery from '../domain/types/graphql/fields/promotions'
import cartProductsFieldsQuery from '../domain/types/graphql/fields/cartProducts'
import { gql } from './gql'

/**
 * Get cart fields
 * @internal
 */
export const cartFieldsQuery: string = `
  items {
    ${cartProductsFieldsQuery}
  }
  groups {
    groupBy
    items {
      ${cartProductsFieldsQuery}
    }
    total
    subtotal
  }
  id
  status
  customFields
  createdAt
  updatedAt
  total
  subtotal
  warnings
  activeFees {
    total
    fee
    {
      fee
      threshold
      type
    }
  }
  activePromotions {
    complexConfiguration {
      selectedGroupIdentifier
    }
    freeGoods {
      consumed {
        quantity
        sku
        packageName
      }
      count
      items {
        quantity
        sku
        packageName
      }
    }
    count
    pricePerItem
    itemsConsumed
    label
    promotion {
      ${promotionsFieldsQuery}
    }
  }
  deferredPromotions {
    count
    complexConfiguration {
      selectBy,
    }
    promotion {
      ${promotionsFieldsQuery}
    }
  }
`

/**
 * Get's the string for `cart` query.
 * This query gets all existing items in the current cart.
 */
export const GET_CART = gql`
  query cart(
    $cartStorefrontName: String!,
    $cartSessionUid: ID!
  ) {
    cart(storefrontName: $cartStorefrontName, sessionUid: $cartSessionUid) {
      ${cartFieldsQuery}
    }
  }
`
